import axios from 'axios'
import findIndex from 'lodash/findIndex'
import get from 'lodash/get'

// eslint-disable-next-line no-warning-comments
// TODO - Move set_loading here for all requests !!!

const API = {
  apiClient: null,
  baseUrl: process.env.VUE_APP_BACKEND + '/api/r/v1',

  dialog: null,
  router: null,
  store: null,
  events: null,
  dialogInstance: null,

  init() {
    console.log('API - init')

    return new Promise((resolve, reject) => {
      //- Axios instance
      this.apiClient = axios.create({
        baseURL: this.baseUrl,
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })

      //- Timeout
      this.apiClient.defaults.timeout = 60000

      // Handle errors (unless told not to)
      const errorHandler = error => {
        if (!error.config || (error.config && !error.config.handleErrors)) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx

            // 400
            // 401
            // 403
            // 404
            // 406

            switch (error.response.status) {
              case 400:
                console.log(error.response.status)
                console.log(error.response.data)
                break
              case 401:
                console.log(error.response.status)
                console.log(error.response.data)
                break
              case 404:
                console.log(error.response.status)
                console.log(error.response.data)
                break
              case 406:
                //- Not acceptable - token is invalid
                if (this.dialog && this.dialogInstance === null) {
                  this.store.dispatch('currentuser/setCurrentUser', null)
                  this.store.dispatch('user/clearInitiatorUser')
                  this.store.dispatch('currentuser/setNotifications', [])
                  this.events.fire('loggedOut')
                  // eslint-disable-next-line max-depth
                  if (this.router.history.current.path != '/') {
                    this.router.push('/')
                  }
                  this.dialogInstance = this.dialog
                    .confirm({
                      title: 'Du har blivit utloggad',
                      text: 'Var vänlig logga in igen för att fortsätta.',
                      actions: [{ true: true, text: this.$t('menu.login-btn'), icon: '$sl-login' }]
                    })
                    .finally(() => {
                      this.dialogInstance = null
                    })
                } else {
                  console.log(error.response.status)
                  console.log(error.response.data)
                }
                break
              case 422:
                //- All validation errors
                // eslint-disable-next-line no-case-declarations
                const dataErrors = get(error,'response.data.errors', null)
                // eslint-disable-next-line no-case-declarations
                let messages = []
                if (dataErrors) {
                  messages = dataErrors.map(e => {
                    return e.message ? e.message : e.msg
                  })
                } else {
                  messages = [get(error, 'response.data.message', 'Okänt fel')]
                }
                // eslint-disable-next-line no-case-declarations
                const message = Array.from(new Set(messages)).join(' - ')
                if (this.dialog) {
                  this.dialog.notify.error(message, {
                    position: 'top-right',
                    timeout: 2000
                  })
                }
                console.log(error.response.status)
                console.log(error.response.data)
                break
              default:
                console.log(error.response.status)
                console.log(error.response.data)
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            if (this.dialog) {
              this.dialog.notify.error(error.message, {
                position: 'top-right',
                timeout: 2000
              })
            } else {
              console.log(error.request)
            }
          } else {
            // Something happened in setting up the request that triggered an Error
            // eslint-disable-next-line no-lonely-if
            if (this.dialog) {
              this.dialog.notify.error(error.message, {
                position: 'top-right',
                timeout: 2000
              })
            } else {
              console.log(error.message)
            }
          }
        }
        if (this.store) {
          this.store.dispatch('app/set_loading', false)
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ ...error })
      }

      // Handle responses (unless told not to)
      const successHandler = response => {
        if (!response.config || (response.config && !response.config.handleResponse)) {
          if (this.store) {
            this.store.dispatch('app/set_loading', false)
          }
        }
        return response
      }

      this.apiClient.interceptors.response.use(
        response => successHandler(response),
        error => errorHandler(error)
      )

      //- Return client or Error
      if (this.apiClient) {
        resolve(this.apiClient)
      } else {
        reject(new Error('Failed to initialize API'))
      }
    })
  },

  //- Housekeeping
  setHeaders(key, val) {
    this.apiClient.defaults.headers.common[key] = val
  },
  getBaseUrl() {
    return this.baseUrl
  },

  //- Auth
  getAuth() {
    return this.apiClient.get('/authentication/auth-config')
  },
  personVerify(params) {
    return this.apiClient.post('/persons/verify', params)
  },

  //- Login/logout
  loginUser(params) {
    return this.apiClient.patch('/users/login', params)
  },
  logoutUser() {
    return this.apiClient.patch('/users/logout')
  },
  mobileBankIdLogin(params) {
    return this.apiClient.patch('/users/loginmobilebankid', params)
  },
  bankIdGetToken() {
    return this.apiClient.patch('/users/loginbankid-gettoken')
  },
  bankIdLogin(params) {
    return this.apiClient.patch('/users/loginbankid-login', params)
  },
  bankIdExternal(params) {
    return this.apiClient.patch('/users/loginbankid-external', params)
  },

  //book-pause
  listBookPauses() {
    return this.apiClient.get('/book-pauses/list')
  },
  listPauseBooks() {
    return this.apiClient.patch('/book-pauses/list')
  },
  denyPauseBook(id) {
    return this.apiClient.patch('/book-pauses/' + id + '/reject')
  },
  deletePauseBook(id) {
    return this.apiClient.delete('/book-pauses/delete/' + id)
  },
  undoApprovePauseBook(id){
    return this.apiClient.patch('/book-pauses/' + id + '/undo-approve')
  },
  approvePauseBook(id) {
    return this.apiClient.patch('/book-pauses/' + id + '/approve')
  },
  createPauseBook(bookId, params) {
    return this.apiClient.post('/books/' + bookId + '/book-pauses/create', params)
  },
  updatePauseBook(pauseId, params) {
    return this.apiClient.patch('/book-pauses/' + pauseId + '/update', params)
  },
  //- Documents
  getDocuments(id) {
    return this.apiClient.get('/documents/get/' + id, { responseType: 'arraybuffer' })
  },
  getApplicationDocuments(id) {
    return this.apiClient.get('/application-documents/get/' + id, { responseType: 'arraybuffer' })
  },
  //- Ebook
  getBook(id) {
    return this.apiClient.get('/books/get/' + id)
  },
  setBookStatus(id, params) {
    return this.apiClient.patch('/books/' + id + '/update', params)
  },
  issueBook(id) {
    return this.apiClient.post('/educations/' + id + '/issue-basic-certificate', {})
  },
  approveBook(id) {
    return this.apiClient.patch('/educations/' + id + '/approve-basic-certificate')
  },
  deleteBook(id) {
    return this.apiClient.delete('/books/delete/' + id)
  },
  createBookElement(id, params) {
    return this.apiClient.post(`/books/${id}/create-element`, params)
  },
  deleteBookElement(id) {
    return this.apiClient.delete(`/books/delete-element/${id}`)
  },
  deleteBookSubElement(elementId, id) {
    return this.apiClient.delete(`/books/${elementId}/delete-sub-element/${id}`)
  },
  approveBookElement(id, params) {
    return this.apiClient.patch(`/books/update-element/${id}`, params)
  },
  approveBookSubElement(id, params) {
    return this.apiClient.patch(`/books/${id}/update-sub-element`, params)
  },
  approveAllElements(params) {
    return this.apiClient.patch(`/books/update-all-elements`, params)
  },
  
  //- Notifications
  listNotifications(params) {
    return this.apiClient.patch('/notifications/list', params)
  },
  readNotifications(params) {
    return this.apiClient.patch('/notifications/mark-read', params)
  },

  //- Notes
  listNotes(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/notes/list', params)
  },
  deleteNote(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete(`/notes/${id}/delete`)
  },
  createNote(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post(`/notes/create`, params)
  },

  //- Employments
  setEmployment(employment) {
    if (employment.id) {
      return this.apiClient.patch('/employments/update/' + employment.id, {
        data: employment
      })
    }
    return this.apiClient.post('/employments/create', {
      data: employment
    })
  },

  getEmployment(id) {
    return this.apiClient.get('/employments/get/' + id)
  },
  deleteEmployment(id) {
    return this.apiClient.delete('/employments/delete/' + id)
  },
  //Employement workplaces
  createEmploymentWorkplaces(params) {
    return this.apiClient.post('/employmentworkplaces/create/', params)
  },
  //- Apprenticeships
  setApprenticeship(apprenticeship) {
    if (apprenticeship.id) {
      return this.apiClient.patch('/apprenticeships/update/' + apprenticeship.id, {
        data: apprenticeship
      })
    }
    return this.apiClient.post('/apprenticeships/create', {
      data: apprenticeship
    })
  },
  extendApprenticeship(apprenticeshipId, params) {
    return this.apiClient.patch('/apprenticeships/' + apprenticeshipId + '/extend', params)
  },
  getApprenticeship(id) {
    return this.apiClient.get('/apprenticeships/get/' + id)
  },
  deleteApprenticeship(id) {
    return this.apiClient.delete('/apprenticeships/delete/' + id)
  },
  endApprenticeship(id, params) {
    return this.apiClient.post('/apprenticeships/end/' + id, params)
  },

  //- Users
  listUsers(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/users/list', params)
  },
  getUser(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/users/get/' + id)
  },
  deleteUser(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/users/delete/' + id)
  },
  setUser(user) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    if (user.id) {
      return this.apiClient.put('/users/update/' + user.id, user)
    }
    return this.apiClient.post('/users/create', user)
  },
  selectUser(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/users/select', params)
  },
  setUserPassword(body) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.put('/users/changepassword/' + body.data.id, body)
  },

  //- Companies
  listCompanies(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/list', params)
  },
  widgetListCompanies(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/widgetlist', params)
  },
  listCompaniesSelect(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/select', params)
  },
  setCompany(company) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    if (company.id) {
      return this.apiClient.patch('/companies/update/' + company.id, {
        data: company
      })
    }
    return this.apiClient.post('/companies/create', {
      data: company
    })
  },
  getCompany(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/companies/get/' + id)
  },
  getCompanyOrg(org) {
    return this.apiClient.patch('/companies/list', { organizationalNumber: String(org) })
  },
  getBolagsverketCompany(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/get-bolagsverket', params)
  },

  deleteCompany(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/companies/delete/' + id)
  },
  approveCompany(id, text) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/approve/' + id, text)
  },
  //- Departments
  listDepartments(companyId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/' + companyId + '/departments/list')
  },
  createDepartment(companyId, department) {
    if (department && department.data && department.data.id) {
      return this.apiClient.patch(
        '/companies/' + companyId + '/departments/' + department.data.id + '/update',
        department
      )
    }
    return this.apiClient.post('/companies/' + companyId + '/departments/create', department)
  },
  deleteDepartment(companyId, departmentId) {
    return this.apiClient.delete('/companies/' + companyId + '/departments/' + departmentId + '/delete')
  },
  //- Workplaces
  getWorkplaces(id) {
    return this.apiClient.get('/companies/' + id + '/workplaces')
  },
  getWorkplace(id, workplaceId) {
    return this.apiClient.get('/companies/' + id + '/workplace/' + workplaceId)
  },
  updateWorkplace(id, workplaceId, params) {
    return this.apiClient.patch('/companies/' + id + '/workplace-update/' + workplaceId, params)
  },
  createWorkplace(id, params) {
    return this.apiClient.post('/companies/' + id + '/workplace-create', params)
  },
  deleteWorkplace(id, workplaceId) {
    return this.apiClient.delete('/companies/' + id + '/workplace-delete/' + workplaceId)
  },

  //- Employees
  listEmployes(params) {
    return this.apiClient.patch('/persons/employments', params)
  },

  listPersonsSelect(params) {
    return this.apiClient.patch('/persons/select', params)
  },

  // -Regions
  listRegions(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/regions/list', params)
  },

  //- Apprentices
  listCompanyApprenticenships(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/' + id + '/apprenticeships')
  },
  listPersonsApprenticenships(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/persons/' + id + '/apprenticeships')
  },
  listCompanyEmployments(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/companies/' + id + '/employments')
  },
  //- Apprentices
  listApprenticeships(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/persons/' + id + '/apprenticeships', params)
  },
  createApprenticeships(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/apprenticeships/create', params)
  },
  createApprentice(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/persons/create-apprentice', params)
  },
  updateApprenticeship(id, d) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/apprenticeships/update/' + id, d)
  },
  moveApprenticeship(id, companyId, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/apprenticeships/' + id + '/move/' + companyId, params)
  },

  //- Persons
  listPersons(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/persons/list', params)
  },
  getSparPerson(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/persons/get-spar', params)
  },
  listPersonDistanceOrders(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/persons/' + id + '/distance-orders', params)
  },

  getPersonBooks(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/persons/' + id + '/get-books')
  },
  deletePerson(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/persons/delete/' + id)
  },
  changePersonPassword(body) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.put('/persons/changepassword/' + body.data.id, body)
  },
  orderTradeCertDuplicate(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/persons/' + id + '/order-trade-certificate-duplicate', params)
  },
  //- Applications
  listApplications(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/applications/list', params)
  },
  updateApplication(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/applications/update/' + id, params)
  },
  createApplication(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/applications/create', params)
  },
  deleteApplication(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/applications/delete/' + id)
  },
  changeStateApplication(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/applications/change-state/' + id, params)
  },
  //- Application-documents
  getApplicationDocument(id) {
    return this.apiClient.get('/application-documents/get/' + id, { responseType: 'arraybuffer' })
  },
  //- Messages
  sendMessage(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/messages/send', params)
  },

  //- Person
  getPerson(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    // Use the new endpoint with additional joinings
    // the legacy one /persons/get/${id}
    return this.apiClient.get('/persons/get-fixed/' + id)
      .then(person => {
        return this.apiClient.get('/persons/' + id + '/list-educations')
          .then(educations => {
            try {
              educations.data.forEach(e => {
                const po = (Array.isArray(e.educationProfessionOrientations) ? e.educationProfessionOrientations : []).map(o => o.professionMachineOrientationId)
                const i = findIndex(person.data.educations, ['id', e.id]);
                if (i > -1 && po.length > 0) {
                  if (!person.data.educations[i].extendedInfo) {
                    person.data.educations[i].extendedInfo = {}
                  }
                  person.data.educations[i].extendedInfo.professionOrientations = po
                }
              })
              return person
            } catch (e) {
              return person
            }
          })
      })
  },
  setPerson(person) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    if (person.id) {
      return this.apiClient.patch('/persons/update/' + person.id, {
        data: person
      })
    }
    return this.apiClient.post('/persons/create', {
      data: person
    })
  },
  updatePerson(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/persons/update/' + id, { data: params })
  },
  loginAsHash(personId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/persons/login-hash', { personId })
  },
  loginAsUserHash(userId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/users/login-hash', { userId })
  },

  //- Professsions
  getProfession(id) {
    return this.apiClient.get('/professions/get/' + id)
  },
  listProfessions(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/professions/list', params)
  },
  listProfessionElements(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(`/professions/${id}/fetch-elements`)
  },
  listTheoreticalElements(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(`/distance-education-provider-courses/${id}/fetch-courses`)
  },
  updateProfessions(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/professions/update/' + id, params)
  },

  createProfessions(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/professions/create', params)
  },

  deleteProfessions(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/professions/delete/' + id)
  },
  //- Machines
  listMachines(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/machines/list', params)
  },
  createMachineCertification(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/machine-qualifications/create', params)
  },
  deleteMachineQualification(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('machine-qualifications/' + id + '/delete')
  },
  approveMachinesQualification(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('machine-qualifications/' + id + '/approve')
  },
  widgetBookPauses(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/book-pauses/widgetlist', params)
  },
  widgetBooks(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/books/widgetlist', params)
  },
  listInactiveBooks(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/books/list-inactive', params)
  },
  widgetMachineCertification(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/machine-qualifications/widgetlist', params)
  },
  //- InstructorExemptions
  createInstructorExemptions(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/instructor-exemptions/create', params)
  },
  approveInstructorExemptions(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/instructor-exemptions/' + id + '/approve')
  },
  updateExemption(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/instructor-exemptions/' + id + '/update/', params)
  },
  issueExemption(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('instructor-exemptions/' + id + '/issue/', params)
  },
  deleteExemption(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/instructor-exemptions/delete/' + id)
  },
  widgetInstructorExemptions(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/instructor-exemptions/widgetlist', params)
  },

  // getProfessionsModules(id) {
  //   if (this.store) {
  //     this.store.dispatch('app/set_loading', true)
  //   }
  //   return this.apiClient.get('professions/fetch-courses/'+id)
  // },

  //- Professsion Courses
  previewCourses(id, courseIds){
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(`/professions/${id}/get-preview-courses`, { params: { courseIds } })
  },
  listProfessionCourses(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/professions/' + id + '/courses', params)
  },
  listPlainProfessionCourses(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/professions/' + id + '/courses?plain=true', params)
  },
  deleteProfessionCourses(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/professioncourses/delete', params)
  },

  createProfessionCourses(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/professioncourses/create', params)
  },
  //- fetch-courses
  listFetchCourses(id, applicationId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(
      '/professions/fetch-courses/' + id + (applicationId ? '?applicationId=' + applicationId : '')
    )
  },
  //- Courses
  listCourses(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/courses/list', params)
  },

  updateCourse(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/courses/${id}/update`, params)
  },

  listProfessionCourseTheoryCourses(id, professionId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/professioncourses/' + id + '/theory-courses?professionId=' + professionId)
  },
  listDistanceEducationProviderCourses(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }

    return this.apiClient.get('professions/' + id + '/distance-education-provider-courses/list')
  },

  listDistanceEducations(distanceEducationProviderId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/distance-education-provider-courses/listall', { params: {
      distanceEducationProviderId
    } })
  },
  listDistanceEducationProviderExtensions(distanceEducationProviderId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/distance-education-provider-extension/listall', { params: {
      distanceEducationProviderId
    } })
  },
  createDistanceEducationProviderExtension(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/distance-education-provider-extension/create', params)
  },
  updateDistanceEducationProviderExtension(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.put('/distance-education-provider-extension/' + id + '/update', params)
  },
  listPersonEducations(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/persons/' + id + '/list-educations')
  },
  updateDistanceEducations(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/distance-education-provider-courses/' + id + '/update', params)
  },
  updateDistanceCourse(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/books/' + id + '/update-course', params)
  },
  deleteDistanceCourse(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/books/' + id + '/delete-course')
  },
  updateAssignments(bookId, elId, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/book-assignments/${bookId}/update/${elId}`, params)
  },

  getProfessionCoursePracticalCourses(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/professioncourses/' + id + '/get-course')
  },
  createProfessionCourseTheoryCourses(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/professioncourses/' + id + '/create-theory-course', params)
  },
  deleteProfessionCourseTheoryCourses(courseId, pctcId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/professioncourses/' + courseId + '/delete-theory-course/' + pctcId)
  },
  //- Education
  createEducation(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/applications/' + id + '/issue-basic-certificate', params)
  },
  undoCreateEducation(id){
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
      return this.apiClient.post('/applications/' + id + '/undo-issue-basic-certificate')
    }
  },
  approveEducation(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/educations/' + id + '/approve-basic-certificate/', params)
  },
  deleteEducation(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/educations/' + id + '/delete-basic-certificate/')
  },
  denyEducation(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/educations/' + id + '/reject-basic-certificate/', params)
  },
  extendEducation(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/education-extension/create', params)
  },
  getExtendedEducation(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(`/education-extension/${id}/get`)
  },
  getEducationExtensions(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(`/education-extension/${id}/listall`)
  },
  updateExtendedEducation(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/education-extension/update`, params)
  },
  deleteExtendedEducation(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete(`/education-extension/${id}/delete`)
  },
  rejectExtendedEducation(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/education-extension/${id}/reject`)
  },
  approveExtendedEducation(id, companyId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/education-extension/${id}/approve`, {
      companyId
    })
  },
  getEducationExtensionWidget(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/education-extension/widgelist`, params)
  },
  listEducationTypes() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/education-types/list')
  },

  educationWidget(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/educations/widgetlist/', params)
  },
  //- Distance Education providers
  listDistanceEducationProviders() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('distance-education-providers/list')
  },
  createDistanceEducationProviderCourse(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/books/create-course', params)
  },
  //- Qualification time
  createQualificationTimeModification(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/qualification-time-modifications/create/', params)
  },
  getQualificationTime(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/educations/' + id + '/qualification-time/')
  },
  deleteQualificationTime(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete(`/qualification-time/${id}/delete`)
  },
  getPersonQualificationTime(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/persons/' + id + '/qualification-time/')
  },
  deletePersonQualificationTimeModification(id) {
    return this.apiClient.delete('/qualification-time-modifications/' + id + '/delete')
  },
  denyPersonQualificationTimeModification(id) {
    return this.apiClient.patch('/qualification-time-modifications/' + id + '/reject')
  },
  approvePersonQualificationTimeModification(id) {
    return this.apiClient.patch('/qualification-time-modifications/' + id + '/approve')
  },
  updatePersonQualificationTimeModification(id, params) {
    return this.apiClient.patch('/qualification-time-modifications/' + id + '/update', params)
  },
  getQualificationTimeWidget(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/qualification-time-modifications/widgetlist', params)
  },
  updateQualificationTime(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/qualification-time/${id}/update`, params)
  },

  getPersonDiverseQualifications(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/persons/' + id + '/diverse-qualifications/')
  },
  deleteDiverseQualifications(id) {
    return this.apiClient.delete('/diverse-qualifications/delete/' + id)
  },
  createDiverseQualifications(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/diverse-qualifications/create/', params)
  },
  listQualificationTime(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/qualification-time/widgelist', params)
  },
  issueQualificationTime(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/qualification-time/issue-qualification-time/${id}`, params)
  },
  revokeAdminApproveQualificationTime(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/qualification-time/revoke-admin-approval/${id}`)
  },
  approveQualificationTime(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/qualification-time/approve-qualification-time/${id}`, params)
  },

  //- Distance Orders
  listDistanceOrders(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('distance-orders/list', params)
  },

  exportDistanceOrders(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('distance-orders/export-order', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },
  getDefaultQualificationTime(profId, appId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/professions/' + profId + '/default-qualification-time?applicationId=' + appId)
  },
  listDistanceOrderCourses(id, applicationId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(
      '/professions/fetch-courses/' + id + (applicationId ? '?applicationId=' + applicationId : '')
    )
  },
  //- Orders
  createDistanceOrder(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/distance-orders/create', params)
  },
  undoCreateDistanceOrder(applicationId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/distance-orders/undo/', { applicationId })
  },
  getDistanceOrder(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/distance-orders/get/' + id)
  },
  getExtensionOrder(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/extension-orders/get/' + id)
  },

  deleteDistanceOrder(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/distance-orders/delete/' + id)
  },

  updateDistanceOrder(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/distance-orders/update/' + id, params)
  },
  updateExtensionOrder(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/extension-orders/update/' + id, params)
  },
  listDistanceOrderStates() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('distance-order-states/list')
  },
  listExtensionOrderStates() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('extension-order-states/list')
  },
  listOrders(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('orders/list', params)
  },
  widgetPrintOrders(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('print-orders/widgetlist', params)
  },

  // TradeCertificates
  approveTradeCertificate(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('trade-certificates/' + id + '/approve', params)
  },
  deleteTradeCertificate(id) {
    return this.apiClient.delete('trade-certificates/' + id + '/delete')
  },
  createTradeCertificate(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('trade-certificates/create', params)
  },
  widgetTradeCertificate(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('trade-certificates/widgetlist', params)
  },

  // Replacement card
  orderReplacementCard(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post(`/persons/${id}/request-trade-certificate`, params)
  },

  //- Contract Type
  listContractTypes(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/contract-types/list', params)
  },
  updateContractTypes(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/contract-types/update/' + id, params)
  },
  createContractTypes(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/contract-types/create', params)
  },
  deleteContractTypes(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/contract-types/delete/' + id)
  },

  //- Employment Types
  listEmploymentTypes(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/employment-types/list', params)
  },
  updateEmploymentTypes(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/employment-types/update/' + id, params)
  },
  createEmploymentTypes(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/employment-types/create', params)
  },
  deleteEmploymentTypes(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/employment-types/delete/' + id)
  },

  //- Employment Roles
  listEmploymentRoles(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/employment-roles/list', params)
  },
  updateEmploymentRoles(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/employment-roles/update/' + id, params)
  },
  createEmploymentRoles(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/employment-roles/create', params)
  },
  deleteEmploymentRoles(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/employment-roles/delete/' + id)
  },

  //- User Role
  listUserRoles() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/user-roles/list')
  },

  //- Application States
  listApplicationStates() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/application-states/list')
  },
  getApplication(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/applications/get/' + id)
  },
  getApplicationStateLogs(id) {
    return this.apiClient.get('/applications/get-statelogs/' + id)
  },
  createApplicationDocument(params, options) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/application-documents/create/', params, options)
  },
  deleteApplicationDocument(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/application-documents/delete/' + id)
  },

  //- Print card order
  createPrintOrders(educationId, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('educations/' + educationId + '/create-machine-certificate', params)
  },
  getPersonPrintOrders(personId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('persons/' + personId + '/print-orders/')
  },
  getPersonsPrintOrders() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('persons/select')
  },
  getPrintOrdersList(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/print-orders/list', params)
  },
  getPrintOrdersStateList() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/print-order-states/list')
  },
  getPrintOrdersById(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/print-orders/' + id + '/get')
  },
  updatePrintOrdersById(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/print-orders/' + id + '/update', params)
  },
  deletePrintOrdersById(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/print-orders/' + id + '/delete')
  },
  approvePrintOrdersById(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/print-orders/' + id + '/approve')
  },
  getEducationsSelectMachines(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/educations/select-machine-certificate-educations', params)
  },
  getFailedEducations(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/educations/failed', params)
  },
  resendEducation(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/educations/resend', { id })
  },
  markAsSent(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/educations/mark-as-sent', { id })
  },
  //- SEQF Sections
  selectSections(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/sections/select', params)
  },
  updateSection(params, id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/sections/update/' + id, params)
  },
  createSection(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/sections/create', params)
  },
  deleteSection(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/sections/delete/' + params)
  },

  // Elements and subElements
  createElement(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/elements/create', params)
  },
  pasteElements(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/elements/paste-elements', params)
  },
  updateElement(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/elements/' + id + '/update', params)
  },
  moveElement(id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/elements/' + id + '/move', params)
  },
  deleteElement(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/elements/' + id + '/delete')
  },
  createSubElement(elementId, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/elements/' + elementId + '/create-subelement', params)
  },
  updateSubElement(elementId, id, params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/elements/' + elementId + '/update-subelement/' + id, params)
  },
  deleteSubElement(elementId, id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.delete('/elements/' + elementId + '/delete-subelement/' + id)
  },

  //- Insturctor Instructions
  getCurrentInstructions() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/instructions/get-current')
  },
  getInstructions(id) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get(`/instructions/${id}/get`)
  },
  updateInstructions(id, data) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/instructions/${id}/update`, { data })
  },
  publishInstructions(data) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/instructions/publish`, { data })
  },

  //- Statistics
  getGUStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gu/', params)
  },
  exportGUStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gu/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getKtidStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/ktid/', params)
  },
  exportKtidStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/ktid/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getGUNeedCompletionStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gu/', {...params, needCompletion: true})
  },
  exportGUNeedCompletionStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gu/', {...params, needCompletion: true}, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getGUNeedCompleteEducationStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gu/', {...params, needCompleteEducation: true})
  },
  exportGUNeedCompleteEducationStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gu/', {...params, needCompleteEducation: true}, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getTCStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/tc/', params)
  },
  exportTCStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/tc/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getApplicationStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/app/', params)
  },

  exportApplicationStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/app/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getGUKTStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gukt/', params)
  },

  exportGUKTStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/gukt/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  timeKTStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/timekt/', params)
  },

  exportTimeKTStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/timekt/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  timeBEStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/timebe/', params)
  },

  exportTimeBEStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/timebe/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getDeviationsBEStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/devbe/', params)
  },

  exportDeviationsBEStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/devbe/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  getDeviationsQTStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/devqt/', params)
  },

  exportDeviationsQTStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/statistics/devqt/', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  postScbStatistics(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/statistics/scb', params, {
      headers: {
        Accept: 'application/json, text/xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
  },

  //- Logging
  listLoginLog(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/login-log/list/', params)
  },

  //- System Settings
  getSystemSettings() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/system-settings/get')
  },
  saveSystemSettings(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch('/system-settings/update', params)
  },

  //- Comments
  addComment(params) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.post('/comments/create', params)
  },

  // school
  listSchool() {
    return this.apiClient.get(`/school/list`)
  },

  //- Version
  getVersion() {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.get('/app/version')
  },

  //- Release notes
  listReleaseNotes(application, status) {
    const params = {}
    if (application) params.application = application
    if (status) params.status = status
    return this.apiClient.get('/release-notes/list', {params})
  },
  createReleaseNote(params) {
    return this.apiClient.post('/release-notes/create', params)
  },
  getReleaseNote(id) {
    return this.apiClient.get(`/release-notes/get/${id}`)
  },
  updateReleaseNote(id, params) {
    return this.apiClient.put(`/release-notes/update/${id}`, params)
  },
  markReleaseNotesAsRead(params) {
    return this.apiClient.patch(`/release-notes/mark-as-read`, params)
  },

  // Special course approval
  startSpecialCourseApproval(params) {
    return this.apiClient.post(`/special-course-approval/create`, params)
  },
  specialCourseApprovalWidget(params) {
    return this.apiClient.post(`/special-course-approval/widgetlist`, params)
  },
  getSpecialCourseApproval(id) {
    return this.apiClient.get(`/special-course-approval/${id}/get`)
  },
  completeSpecialCourseApproval(id) {
    return this.apiClient.patch(`/special-course-approval/${id}/approve`)
  },
  destroySpecialCourseApproval(id) {
    return this.apiClient.delete(`/special-course-approval/${id}/delete`)
  },
  changeEducationRegion(educationId, regionId) {
    if (this.store) {
      this.store.dispatch('app/set_loading', true)
    }
    return this.apiClient.patch(`/educations/${educationId}/change-region`, { regionId })
  }
}

export default API
